import { useEffect, useState } from 'react';
import { useAppSelector } from 'store/store-hooks';
import { useLocation, Path } from 'components/_hooks/use-router';

const VAR__EXPANDED__TRACKS = '--expanded-tracks';
const VAR__TRANSITION = '--transition-time';
const TRANSITION_VAL = 0.2;

export const useSbView = (rootRef: React.RefObject<HTMLDivElement>, styles: CSSModuleClasses) => {
  const sbViewMode = useAppSelector((state) => state.sb.sbViewMode);
  const [classes, setClasses] = useState<string[]>([]);
  const { path } = useLocation();

  const setTransition = (transition: boolean) => {
    rootRef.current?.style.setProperty(VAR__TRANSITION, (transition ? TRANSITION_VAL : 0) + 's');
  };

  useEffect(() => {
    setTransition(false);
  }, [path]);

  useEffect(() => {
    if (path !== Path.storyboard) return;
    setTransition(true);
  }, [sbViewMode]);

  useEffect(() => {
    const result = [];
    const expandedElements = 3 - Object.values(sbViewMode.sbTracks).filter(Boolean).length;
    rootRef.current?.style.setProperty(VAR__EXPANDED__TRACKS, `${expandedElements}`);
    result.push(styles[`Layout--sb-exp${expandedElements}`]);
    if (!expandedElements) result.push(styles['Layout--sb-empty']);
    if (!sbViewMode.audio) result.push(styles['Layout--sb-expAudio']);
    setClasses(result);
  }, [sbViewMode]);

  return classes;
};
